import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Allow access if the user is a super admin OR has at least one of the
// listed page keys granted via their role / per-user overrides.
// `pageKey` may be a single string or an array of acceptable keys.
export default function PageGuard({ pageKey, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'super_admin') return children;
  const allowed = Array.isArray(pageKey) ? pageKey : [pageKey];
  const userPages = Array.isArray(user.pages) ? user.pages : [];
  if (allowed.some((k) => userPages.includes(k))) return children;
  return <Navigate to="/dashboard" replace />;
}
